/* BabyCloud theme · theme.js (sem dependências) */
(() => {
  'use strict';
  const BC = window.BC || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Utilitários ---------- */
  const formatMoney = (cents, format = BC.moneyFormat || '€{{amount_with_comma_separator}}') => {
    const value = Number(cents) || 0;
    const fmt = (n, dec, thou, decSep) => {
      const fixed = (n / 100).toFixed(dec);
      const [int, frac] = fixed.split('.');
      const withThou = int.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return frac ? withThou + decSep + frac : withThou;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmt(value, 2, ' ', '.');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, '.', ',');
      }
    });
  };
  BC.formatMoney = formatMoney;
  const tpl = (str, vars) => String(str || '').replace(/\[(\w+)\]/g, (m, k) => (k in vars ? vars[k] : m));

  let toastTimer;
  const toast = (msg) => {
    const el = $('#bc-toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  };

  const postJSON = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.description || data.message || BC.strings.cartError);
      err.data = data;
      throw err;
    }
    return data;
  };

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$(`[data-drawer-open="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const panel = $('.drawer__panel', d);
    setTimeout(() => panel && panel.focus({ preventScroll: true }), 50);
  };
  const closeDrawer = (d) => {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $$(`[data-drawer-open="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  BC.openDrawer = openDrawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      openDrawer(id);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Carrinho ---------- */
  const Cart = {
    sections: 'cart-drawer',
    render(sections) {
      if (!sections || !sections['cart-drawer']) return this.refresh();
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('[data-cart-panel]');
      const current = $('#CartDrawer [data-cart-panel]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const count = fresh ? fresh.querySelector('[data-cart-count-source]') : null;
      if (count) this.setCount(count.getAttribute('data-cart-count-source'));
      if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) {
        try { Shopify.PaymentButton.init(); } catch (err) { /* sem botões expresso */ }
      }
    },
    setCount(n) {
      $$('.cart-count').forEach((el) => {
        el.setAttribute('data-count', n);
        el.textContent = Number(n) > 0 ? n : '';
      });
    },
    async refresh() {
      const res = await fetch(`${BC.routes.root}?sections=${this.sections}`);
      const data = await res.json();
      this.render(data);
    },
    async add(items) {
      const data = await postJSON(BC.routes.cartAdd, { items, sections: this.sections, sections_url: window.location.pathname });
      this.render(data.sections);
      openDrawer('CartDrawer');
      document.dispatchEvent(new CustomEvent('bc:cart:added', { detail: { items } }));
      return data;
    },
    async change(line, quantity) {
      const drawer = $('#CartDrawer');
      drawer && drawer.classList.add('is-busy');
      try {
        const data = await postJSON(BC.routes.cartChange, { line: Number(line), quantity: Math.max(0, Number(quantity)), sections: this.sections, sections_url: window.location.pathname });
        this.render(data.sections);
      } catch (err) {
        toast(err.message);
        this.refresh();
      } finally {
        drawer && drawer.classList.remove('is-busy');
      }
    }
  };
  BC.cart = Cart;

  document.addEventListener('click', (e) => {
    const q = e.target.closest('#CartDrawer [data-qty-change]');
    if (q) { e.preventDefault(); Cart.change(q.dataset.qtyChange, q.dataset.qty); return; }
    const nudge = e.target.closest('[data-nudge-add]');
    if (nudge) {
      e.preventDefault();
      const sel = $('[data-nudge-variant]', nudge.closest('[data-cart-nudge]'));
      const id = Number(sel ? sel.value : nudge.dataset.nudgeAdd);
      nudge.classList.add('is-loading');
      Cart.add([{ id, quantity: 1 }]).catch((err) => toast(err.message)).finally(() => nudge.classList.remove('is-loading'));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('#CartDrawer [data-qty-input]');
    if (input) Cart.change(input.dataset.qtyInput, input.value);
  });

  /* ---------- Cabeçalho ---------- */
  class BCHeader extends HTMLElement {
    connectedCallback() {
      const onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 8);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }
  customElements.define('bc-header', BCHeader);

  /* ---------- Rotador de anúncios ---------- */
  class BCRotator extends HTMLElement {
    connectedCallback() {
      this.items = $$('.announcement__item', this);
      this.i = 0;
      const mq = window.matchMedia('(min-width: 990px)');
      if (this.items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => { if (!mq.matches) this.next(); }, Number(this.dataset.interval) || 4000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    show(n) {
      const prev = this.items[this.i];
      this.i = (n + this.items.length) % this.items.length;
      const cur = this.items[this.i];
      if (prev === cur) return;
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      setTimeout(() => prev.classList.remove('is-leaving'), 500);
      cur.classList.add('is-active');
    }
    next() { this.show(this.i + 1); }
  }
  customElements.define('bc-rotator', BCRotator);

  /* ---------- Galeria ---------- */
  class BCGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-gallery-track]', this);
      this.slides = $$('.gallery__slide', this);
      this.dots = $$('[data-gallery-dot]', this);
      this.thumbs = $$('[data-gallery-thumb]', this);
      this.counter = $('[data-gallery-counter]', this);
      this.index = 0;
      if (!this.track || this.slides.length < 2) return;
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) this.setActive(i);
        });
      }, { passive: true });
      this.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-gallery-dot]');
        const thumb = e.target.closest('[data-gallery-thumb]');
        if (dot) this.goTo(Number(dot.dataset.galleryDot));
        if (thumb) this.goTo(Number(thumb.dataset.galleryThumb));
        if (e.target.closest('[data-gallery-prev]')) this.goTo(this.index - 1);
        if (e.target.closest('[data-gallery-next]')) this.goTo(this.index + 1);
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
      });
    }
    goTo(i) {
      const n = (i + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: n * this.track.clientWidth, behavior: 'smooth' });
      this.setActive(n);
    }
    goToMedia(mediaId) {
      const idx = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (idx > -1) this.goTo(idx);
    }
    setActive(i) {
      this.index = i;
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      if (this.counter) this.counter.textContent = `${i + 1} / ${this.slides.length}`;
    }
  }
  customElements.define('bc-gallery', BCGallery);

  /* ---------- Estimativa de entrega ---------- */
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  };
  const renderDelivery = () => {
    if (!BC.delivery || !BC.delivery.enabled) return;
    const els = $$('[data-delivery-text]');
    if (!els.length) return;
    const now = new Date();
    const wd = now.getDay();
    const beforeCutoff = wd !== 0 && wd !== 6 && now.getHours() < BC.delivery.cutoff;
    const base = new Date(now);
    const start = addBusinessDays(base, BC.delivery.min);
    const end = addBusinessDays(base, Math.max(BC.delivery.max, BC.delivery.min));
    let f;
    try { f = new Intl.DateTimeFormat(BC.locale || 'pt-PT', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { f = new Intl.DateTimeFormat('pt-PT', { weekday: 'short', day: 'numeric', month: 'short' }); }
    const lead = beforeCutoff ? tpl(BC.strings.deliveryOrderBy, { hour: BC.delivery.cutoff }) : BC.strings.deliveryOrderToday;
    const text = `${lead} ${tpl(BC.strings.deliveryReceive, { start: `<strong>${f.format(start)}</strong>`, end: `<strong>${f.format(end)}</strong>` })}`;
    els.forEach((el) => { el.innerHTML = text; });
  };

  /* ---------- Caixa de compra ---------- */
  class BCBuyBox extends HTMLElement {
    connectedCallback() {
      const json = $('[data-product-json]', this);
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.variants = new Map(this.product.variants.map((v) => [v.id, v]));
      this.hints = {};
      (this.product.hints || []).forEach((line) => {
        const [k, ...rest] = String(line).split('|');
        if (k && rest.length) this.hints[k.trim().toLowerCase()] = rest.join('|').trim();
      });
      this.form = $('form', this);
      this.offers = $$('.offer', this);
      this.atc = $('[data-atc]', this);
      this.touched = false;
      this.sid = this.dataset.sectionId;
      this.sticky = document.querySelector(`[data-sticky-buy="${this.sid}"]`);
      this.finder = $('[data-finder]', this);

      this.addEventListener('change', (e) => {
        if (e.target.matches('.offer__input')) this.selectOffer(Number(e.target.value));
        if (e.target.matches('input[data-slot]')) { this.touched = true; this.syncSlots(e.target); this.update(); }
      });
      if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-open-finder]')) { e.preventDefault(); this.openFinder(); }
      });
      if (this.finder) this.initFinder();
      if (this.sticky) this.initSticky();
      if (!BC.openFinder && this.finder) BC.openFinder = () => this.openFinder();
      this.update();
    }

    get offerN() {
      const checked = $('.offer__input:checked', this);
      return checked ? Number(checked.value) : 1;
    }
    selectedIds(n = this.offerN) {
      const offer = this.offers.find((o) => Number(o.dataset.offer) === n);
      if (!offer) return [];
      const ids = [];
      for (let i = 1; i <= n; i++) {
        const input = $(`input[data-slot="${i}"]:checked`, offer) || $(`input[data-slot="${i}"]:not(:disabled)`, offer);
        if (input) ids.push(Number(input.value));
      }
      return ids;
    }
    syncSlots(changed) {
      // Ao mudar o tamanho no pack de 1, replica a escolha nas almofadas dos outros packs (até o cliente mexer num pack).
      if (!changed || this.touchedPack) return;
      const offer = changed.closest('.offer');
      if (!offer || Number(offer.dataset.offer) !== 1) return;
      this.offers.forEach((o) => {
        if (o === offer) return;
        $$(`input[data-slot][value="${changed.value}"]`, o).forEach((t) => { if (!t.disabled) t.checked = true; });
      });
    }
    selectOffer(n) {
      this.offers.forEach((o) => o.classList.toggle('is-selected', Number(o.dataset.offer) === n));
      if (n > 1) this.touchedPack = true;
      this.update();
    }
    pctFor(n) {
      const offer = this.offers.find((o) => Number(o.dataset.offer) === n);
      return offer ? Number(offer.dataset.pct) || 0 : 0;
    }
    totals(n) {
      const ids = this.selectedIds(n);
      const full = ids.reduce((s, id) => s + (this.variants.get(id)?.price || 0), 0);
      const pct = this.pctFor(n);
      const total = Math.round(full * (100 - pct) / 100);
      return { ids, full, total, pct, each: ids.length ? Math.round(total / ids.length) : 0 };
    }
    update() {
      const n = this.offerN;
      const t = this.totals(n);
      // preços de todos os packs
      this.offers.forEach((o) => {
        const on = Number(o.dataset.offer);
        const ot = this.totals(on);
        const tot = $('[data-offer-total]', o); if (tot) tot.textContent = formatMoney(ot.total);
        const full = $('[data-offer-full]', o); if (full) full.textContent = formatMoney(ot.full);
        const each = $('[data-offer-each]', o); if (each) each.textContent = formatMoney(ot.each);
      });
      // bloco de preço
      const first = this.variants.get(t.ids[0]);
      const cur = $('[data-price-current]', this);
      const cmp = $('[data-price-compare]', this);
      const save = $('[data-price-save]', this);
      if (cur) cur.textContent = formatMoney(t.total);
      let compare = 0;
      if (t.pct > 0) compare = t.full;
      else if (first && first.compare > first.price) compare = first.compare;
      if (cmp) { cmp.hidden = !compare; cmp.textContent = compare ? formatMoney(compare) : ''; }
      if (save) {
        const diff = compare ? compare - t.total : 0;
        save.hidden = diff <= 0;
        save.textContent = diff > 0 ? tpl(BC.strings.youSave, { amount: formatMoney(diff) }) : '';
      }
      // dica do tamanho
      const offer = this.offers.find((o) => Number(o.dataset.offer) === n);
      if (offer) {
        const hintEl = $('[data-size-hint]', offer);
        if (hintEl) {
          const lines = t.ids.map((id) => this.variants.get(id)).filter(Boolean).map((v) => {
            const h = this.hints[v.title.trim().toLowerCase()];
            return h ? (n > 1 ? `${v.title.replace('-', '–')}: ${h}` : h) : '';
          }).filter(Boolean);
          const uniq = [...new Set(lines)];
          hintEl.textContent = uniq.join(' · ');
          hintEl.hidden = !uniq.length;
        }
      }
      // disponibilidade e botão
      const available = t.ids.length === n && t.ids.every((id) => this.variants.get(id)?.available);
      if (this.atc) {
        this.atc.disabled = !available;
        const label = $('[data-atc-label]', this.atc);
        const price = $('[data-atc-price]', this.atc);
        if (label) label.textContent = available ? BC.strings.addToCart : BC.strings.soldOut;
        if (price) price.textContent = formatMoney(t.total);
      }
      const fallback = $('[data-fallback-id]', this);
      if (fallback && t.ids[0]) fallback.value = t.ids[0];
      if (n === 1 && t.ids[0] && this.dataset.sectionId && document.body.classList.contains('template-product')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', t.ids[0]);
        window.history.replaceState({}, '', url.toString());
      }
      // barra fixa
      if (this.sticky) {
        const sum = $('[data-sticky-summary]', this.sticky);
        const names = t.ids.map((id) => this.variants.get(id)?.title.replace('-', '–')).filter(Boolean);
        if (sum) sum.innerHTML = `<b>${formatMoney(t.total)}</b> · ${n > 1 ? `${n}× ` : ''}${[...new Set(names)].join(', ')}`;
        const btn = $('[data-sticky-atc] .btn__label', this.sticky);
        if (btn) btn.textContent = this.touched || this.touchedPack ? BC.strings.addToCart : (this.sticky.dataset.chooseLabel || btn.textContent);
      }
      this.current = t;
    }
    async submit(e) {
      e.preventDefault();
      const t = this.totals(this.offerN);
      if (!t.ids.length) return;
      const grouped = {};
      t.ids.forEach((id) => { grouped[id] = (grouped[id] || 0) + 1; });
      const items = Object.entries(grouped).map(([id, quantity]) => ({ id: Number(id), quantity }));
      const err = $('[data-form-error]', this);
      if (err) err.hidden = true;
      this.atc.classList.add('is-loading');
      this.atc.setAttribute('aria-busy', 'true');
      try {
        await Cart.add(items);
      } catch (ex) {
        if (err) { err.textContent = ex.message || BC.strings.cartError; err.hidden = false; }
      } finally {
        this.atc.classList.remove('is-loading');
        this.atc.removeAttribute('aria-busy');
      }
    }
    initSticky() {
      const label = $('[data-sticky-atc] .btn__label', this.sticky);
      if (label) this.sticky.dataset.chooseLabel = label.textContent;
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.sticky.classList.toggle('is-visible', show);
        this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-atc]', this.sticky).tabIndex = show ? 0 : -1;
      });
      if (this.atc) io.observe(this.atc);
      $('[data-sticky-atc]', this.sticky).addEventListener('click', () => {
        if (this.touched || this.touchedPack) {
          this.form.requestSubmit ? this.form.requestSubmit() : this.atc.click();
        } else {
          const target = $('.offers', this) || this;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.touched = true;
          setTimeout(() => this.update(), 400);
        }
      });
    }
    /* Assistente de tamanho */
    initFinder() {
      const f = this.finder;
      this.fAge = $('[data-finder-age]', f);
      this.fOut = $('[data-finder-output]', f);
      f.addEventListener('input', () => this.finderUpdate());
      f.addEventListener('change', () => this.finderUpdate());
      f.addEventListener('click', (e) => {
        const step = e.target.closest('[data-finder-step]');
        if (step) { this.fAge.value = Math.min(18, Math.max(1, Number(this.fAge.value) + Number(step.dataset.finderStep))); this.finderUpdate(); }
        if (e.target.closest('[data-close-finder]')) f.close();
        if (e.target.closest('[data-finder-apply]')) this.finderApply();
        if (e.target === f) f.close();
      });
      this.finderUpdate();
    }
    openFinder() {
      if (!this.finder) return;
      if (typeof this.finder.showModal === 'function') this.finder.showModal();
      else this.finder.setAttribute('open', '');
    }
    ranges() {
      return this.product.variants.map((v) => {
        const nums = (v.title.match(/\d+/g) || []).map(Number);
        return { v, min: nums[0] ?? 0, max: nums[1] ?? nums[0] ?? 99 };
      }).sort((a, b) => a.min - b.min);
    }
    recommend(age, pos) {
      const r = this.ranges();
      if (!r.length) return null;
      let idx = r.findIndex((x) => age >= x.min && age < x.max);
      if (idx === -1) idx = age >= r[r.length - 1].min ? r.length - 1 : 0;
      let note = '';
      const cur = r[idx];
      const nearTop = idx < r.length - 1 && age >= cur.max - 1;
      if (pos === 'side' && nearTop) note = BC.finderNotes?.side || '';
      else if (pos === 'belly') note = BC.finderNotes?.belly || '';
      else if (pos === 'moves') note = BC.finderNotes?.moves || '';
      return { variant: cur.v, note };
    }
    finderUpdate() {
      const age = Number(this.fAge.value);
      const yearsLabel = $('small', this.fOut);
      this.fOut.firstChild.nodeValue = String(age);
      if (yearsLabel) yearsLabel.textContent = age === 1 ? (BC.finderNotes?.year || 'ano') : (BC.finderNotes?.years || 'anos');
      const pos = ($('input[type="radio"]:checked', this.finder) || {}).value;
      const rec = this.recommend(age, pos);
      if (!rec) return;
      this.rec = rec;
      const hint = this.hints[rec.variant.title.trim().toLowerCase()] || '';
      $('[data-finder-size]', this.finder).textContent = rec.variant.title.replace('-', '–');
      $('[data-finder-note]', this.finder).textContent = [hint, rec.note].filter(Boolean).join('. ');
    }
    finderApply() {
      if (!this.rec) return;
      const n = this.offerN;
      const offer = this.offers.find((o) => Number(o.dataset.offer) === n);
      const input = offer && $(`input[data-slot="1"][value="${this.rec.variant.id}"]`, offer);
      if (input && !input.disabled) input.checked = true;
      if (n === 1) this.syncSlots(input);
      this.touched = true;
      this.update();
      this.finder.close();
      const target = $('.offers', this);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      toast(tpl(BC.strings.finderResult, { size: this.rec.variant.title.replace('-', '–') }));
    }
  }
  customElements.define('bc-buy-box', BCBuyBox);

  // Botões "Ajuda-me a escolher" fora da caixa de compra
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-open-finder]');
    if (!btn || btn.closest('bc-buy-box')) return;
    if (BC.openFinder) { e.preventDefault(); BC.openFinder(); }
  });

  /* ---------- Demonstração de alinhamento ---------- */
  class BCAlign extends HTMLElement {
    connectedCallback() {
      this.caption = $('[data-align-caption]', this);
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-align-set]');
        if (b) { this.auto = false; this.set(b.dataset.alignSet); }
      });
      this.auto = true;
      const io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && this.auto) {
          io.disconnect();
          setTimeout(() => { if (this.auto) this.set('cloud'); }, 1400);
        }
      }, { threshold: .6 });
      io.observe(this);
    }
    set(state) {
      this.dataset.state = state;
      $$('[data-align-set]', this).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.alignSet === state)));
      if (this.caption) this.caption.textContent = this.caption.dataset[state] || '';
    }
  }
  customElements.define('bc-align', BCAlign);

  /* ---------- Pontos na imagem ---------- */
  class BCHotspots extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const el = e.target.closest('[data-hotspot], [data-hotspot-item]');
        if (!el) return;
        const i = el.dataset.hotspot ?? el.dataset.hotspotItem;
        this.activate(Number(i), !!el.dataset.hotspot);
      });
    }
    activate(i, scrollList) {
      $$('[data-hotspot]', this).forEach((h, k) => h.classList.toggle('is-active', k === i));
      const items = $$('[data-hotspot-item]', this);
      items.forEach((h, k) => h.classList.toggle('is-active', k === i));
      if (scrollList && items[i] && window.innerWidth < 990) items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
  customElements.define('bc-hotspots', BCHotspots);

  /* ---------- Animações ao scroll ---------- */
  const initReveal = (root = document) => {
    const els = $$('.reveal:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || !document.body.classList.contains('has-anim')) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach((el) => io.observe(el));
  };

  /* ---------- Arranque ---------- */
  const boot = () => {
    initReveal();
    renderDelivery();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); renderDelivery(); });
  document.addEventListener('shopify:block:select', (e) => {
    const rot = e.target.closest('bc-rotator');
    if (rot) rot.show(rot.items.indexOf(e.target));
    const hs = e.target.closest('bc-hotspots');
    if (hs) hs.activate($$('[data-hotspot-item]', hs).findIndex((b) => e.target.contains(b)), false);
  });
})();